/**
 * Opens the menu dialog on click
 *
 * @author bgr
 */
import { html, render } from "lit-html";
import { Dialog } from "./Dialog";
import { connect } from "../connect-with-dialog";

class Burger extends HTMLElement {
	constructor() {
		super();
		render(html`<span class="fa fa-bars"></span>`, this);
	}
}

customElements.define("esc-menu-burger", connect(Dialog, Burger));
